export const SMART_VAULT_DOMAIN = 'external/smart-vault';
export const SMART_VAULT_DOMAIN_URL = `/${SMART_VAULT_DOMAIN}/*`;
export const SMART_VAULT_PAGE_TITLE = 'SmartVault Mirror';

/** Deep link to a single account's imported folder tree. */
export const getSmartVaultAccountPath = (accountId: number): string =>
  `/${SMART_VAULT_DOMAIN}/account/${accountId}`;
